let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e0PMn")).then(() => parcelRequire('9laiZ'));